import { ENDPOINTS } from '../constants/endpoints';
import { serviceAxiosInstance, serviceAxiosInstanceFcna } from '../config/api.service.config';

export function getVechileDisposalInfo(customerAccoutNumber, cobusCode, origBranch) {
  return serviceAxiosInstanceFcna.get(
    ENDPOINTS['VECHICLE_DISPOSAL_INFO_BASE_URL'] +
    cobusCode +
    '/' +
    origBranch +
    '/' +
    customerAccoutNumber
  );
}
export function CreateVehicleDisposalInfo(insertvehicladisposaldata) {
  return serviceAxiosInstanceFcna.post(
    ENDPOINTS['VECHICLE_DISPOSAL_INFO_BASE_URL'],
    insertvehicladisposaldata
  );
}
export function UpdateVehicleDisposalInfo(customerAccoutNumber, cobusCode, origBranch, updatevehicleDisposaldata1) {
  return serviceAxiosInstanceFcna.put(
    ENDPOINTS['VECHICLE_DISPOSAL_INFO_BASE_URL'] +
      cobusCode +
      '/' +
      origBranch +
      '/' +
      customerAccoutNumber,
    updatevehicleDisposaldata1
  );
}

export function getAuctionLocationList(countrycode) {
  return serviceAxiosInstance.get(ENDPOINTS['GET_AUCTION_LOCATION'] + countrycode);
}

export function getVCRPDFbytes(vcrarchiveObject) {
  return serviceAxiosInstance.post(ENDPOINTS['GET_VCR_PDFBYTEARRAY'], vcrarchiveObject);
}

export function uploadGiv(vcrarchiveObject, userId) {
  return serviceAxiosInstance.post(ENDPOINTS['UPLOADGIV_CSM'] + userId, vcrarchiveObject);
}
